import { clsx } from 'clsx'

import s from './Banner.module.css'

import bannerImage from 'assets/images/banner-frontend.jpg'

export const Banner = () => {
  return (
    <a
      className={clsx(s.banner, 'container')}
      href="https://it-incubator.io/education/front-end"
      target="_blank"
      rel="noreferrer"
    >
      <img src={bannerImage} alt="banner" />
    </a>
  )
}
